/* eslint-disable import/no-relative-packages */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import { Loader, useModal, Icon } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { wizardMessages } from 'twia-portals-wizard-components-ui';
import { useHistory } from 'react-router-dom';
import _, { update } from 'lodash';
import { useTranslator } from '@jutro/locale';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import { GatewayRenewalService as LoadSaveService } from 'twia-capability-gateway-policyrenewal';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import PaymentPlansTable from 'twia-capability-quoteandbind-residential-react/components/PaymentPlans/PaymentPlansTable';
import InstallmentsPopup from 'twia-capability-quoteandbind-residential-react/components/InstallmentsPopup/InstallmentsPopup';
import TWIASubmissionHelper from 'twia-capability-quoteandbind-residential-react/util/TWIASubmissionHelper';
import TWIAPolicyContactRoleHelper from 'twia-capability-quoteandbind-residential-react/util/TWIAPolicyContactRoleHelper';
import Echeck from 'twia-capability-quoteandbind-residential-react/components/Echeck/Echeck';
import { PolicyService } from 'gw-capability-gateway';
import styles from './PaymentDetailsPage.module.scss';
import metadata from './PaymentDetailsPage.metadata.json5';
import messages from './PaymentDetailsPage.messages';

import { Link } from '@jutro/router';
import { Button } from '@jutro/legacy/components';

function TWIAPaymentDetailsPage(props) {
    const {
        wizardData: submissionVM,
        updateWizardData,
        jumpTo,
        steps
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, setIsLoading] = useState(false);
    const [emailMessage, setEmailMessage] = useState([]);
    const translator = useTranslator();
    const history = useHistory()
    const { authHeader } = useAuthentication();
    const { isComponentValid, onValidate, disregardFieldValidation } = useValidation('TWIAPaymentDetailsPage');
    const [bindDataVM, setBindDataVM] = useState(submissionVM.bindData);
    const offeredQuoteData = _.get(submissionVM, `quoteData.offeredQuotes.value`)[0]
    const eftEnabled = _.get(submissionVM, 'bindData.eftEnabled_TWIA.value');
    const jobID = submissionVM.jobID.value;
    const sessionID = submissionVM.sessionUUID.value;
    const [showError, setShowError] = useState(false);
    const { showModal, showAlert, showConfirm } = useModal();
    const NO_PAYMENT_OPTION_METHODS = ['prem_fina_other', 'ins_direct_pay', 'echeck', 'eft']
    const ADDITIONAL_INTEREST_OPTIONS = ['prem_fina_other', 'mortgagee_escrow'];
    const DISABLE_SUBMIT_OPTIONS = ['ins_direct_pay', 'prem_fina_other'];
    const [showAdditionalIntMessage, setShowAdditionalInterestMessage] = useState(false);
    const [additionalInterest, setAdditionalInterest] = useState();
    const [additionalInterestDetail, setAdditionalInterestDetail] = useState();
    const [showSubmitLoader, setShowSubmitLoader] = useState(false);
    const [paymentPlans, setPaymentPlans] = useState(_.get(submissionVM, 'bindData.paymentPlans.value'))
    const additionalInterestContacts = _.get(submissionVM, 'baseData.policyContactDetails_TWIA.value')
        .filter(c => c.policyContactRoles.some(pcr => pcr.subtype === 'PolicyAddlInterest'));
    const submitted = _.get(submissionVM, 'baseData.periodStatus.value.code') === 'Submitted_Ext';  
    const NO_SAVE_AND_EXIT_OPTIONS = ['echeck', 'eft'];
    const [autoDraft,setAutoDraft] = useState(false);
    const ceUserName = _.get(submissionVM, 'bindData.registeredCEUsername_TWIA.value');
    const contactEmail = _.get(submissionVM, 'bindData.contactEmail');
    const [isAutoPayEnabled, setIsAutoPayEnabled] = useState(false);
    const [validatingEmail, setValidatingEmail] = useState(false);
    const autoPayEnabled = _.get(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value');
    useEffect(() => {
        setIsAutoPayEnabled(autoPayEnabled)
    }, [])
    const getSelectedPaymentMethod = useCallback(() => (!eftEnabled
        ? _.get(submissionVM, `bindData.paymentDetails.nonEFTPaymentMethod_TWIA.value.code`)
        : _.get(submissionVM, `bindData.paymentDetails.paymentMethod_TWIA.value.code`)),
        [eftEnabled, submissionVM]);

    const getSelectedPaymentOption = useCallback(() => (!eftEnabled
        ? _.get(submissionVM, `bindData.paymentDetails.nonEFTPaymentOption_TWIA.value.code`)
        : _.get(submissionVM, `bindData.paymentDetails.paymentOption_TWIA.value.code`)),
        [eftEnabled, submissionVM]);

    const resetElectronicPaymentData = useCallback(() => {
        const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

        if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
            _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData]);

    const getAdditionalInterestData = useCallback((paymentMethod, ai) => {
        if (TWIASubmissionHelper.isHomeOwners(submissionVM.value)) {
            return TWIAPolicyContactRoleHelper.ho
                .policyAdditionalInterestAndContactDetailByPaymentMethod(paymentMethod)(ai);
        }

        if (TWIASubmissionHelper.isCommercialProperty(submissionVM.value)) {
            return TWIAPolicyContactRoleHelper.cp
                .policyAdditionalInterestAndContactDetailByPaymentMethod(paymentMethod)(ai);
        }

        return undefined;
    }, [submissionVM]);

    function removePaymentMethodIfNeeded(methodName, aic) {
        const ret = getAdditionalInterestData(methodName, aic);
        if (_.isEmpty(ret.additionalInterestDetail)) {
            const paymentMethod = _.get(submissionVM,'bindData.paymentDetails.paymentMethod_TWIA');
            _.remove(paymentMethod.aspects.availableValues, value => value.code === methodName);
            const nonEFTPaymentMethod =_.get(submissionVM,'bindData.paymentDetails.nonEFTPaymentMethod_TWIA');
            _.remove(nonEFTPaymentMethod.aspects.availableValues, value => value.code === methodName);
        }
    }

    useEffect(() => {
        resetElectronicPaymentData();

        let paymentMethod = getSelectedPaymentMethod();

        setIsLoading(true);
        
        const bindDataCall = LoadSaveService.retrieveBindDataWithPaymentPlans([jobID], authHeader);

        bindDataCall.then(() => {
            // DE17457
            const setPaymentValue = LoadSaveService.setDefaultPayment_TWIA([jobID], authHeader);

            setPaymentValue.then(async(renewalData) => {
                _.set(submissionVM, 'bindData.value', renewalData);
                const electronicPaymentData = _.clone(_.get(submissionVM, 
                    'bindData.paymentDetails.electronicPaymentData_TWIA.value'));
                resetElectronicPaymentData();
                // DE18575 Default Payment Method to Insured Direct Pay 
                // if no Mortgagee exists and Mortgagee Escrow is unavailable
                if (additionalInterestContacts.length === 0) {
                    if(!eftEnabled) {
                        _.set(submissionVM, 'bindData.paymentDetails.nonEFTPaymentMethod_TWIA', 'ins_direct_pay')
                    } else{
                        _.set(submissionVM, 'bindData.paymentDetails.paymentMethod_TWIA', 'ins_direct_pay')
                    }
                }
                // DE17461
                if (submitted) {
                    removePaymentMethodIfNeeded('mortgagee_escrow', additionalInterestContacts);
                    removePaymentMethodIfNeeded('prem_fina_other', additionalInterestContacts);
                }
                const responseData = await LoadSaveService.updateQuotedRenewal(
                    [submissionVM.value],
                    authHeader
                )
                if (eftEnabled) {
                    _.set(submissionVM, 'bindData.paymentDetails.paymentOption_TWIA.value', 
                        responseData?.bindData?.paymentDetails?.paymentOption_TWIA)
                } else {
                    _.set(submissionVM, 'bindData.paymentDetails.nonEFTPaymentOption_TWIA.value', 
                        responseData?.bindData?.paymentDetails?.nonEFTPaymentOption_TWIA);
                }
                _.set(submissionVM, 'bindData.paymentPlans.value', 
                    responseData?.bindData?.paymentPlans);
                _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', 
                    electronicPaymentData)
                paymentMethod = getSelectedPaymentMethod();
                setSelectedPaymentPlan();
                CustomQuoteService.maxAmountCanFinance(jobID, authHeader).then(amount => {
                    _.set(submissionVM, 'bindData.paymentDetails.maximumFinancedAmount_TWIA.value',
                        amount || {});
    
                    if (paymentMethod === 'echeck') {
                        submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value =
                            submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value || {}
                        updateWizardData(submissionVM);
                    }

                    // DE17446
                    PolicyService.getPolicyBillingSummaryInfo(
                        submissionVM.value.policyNumber,
                        authHeader
                    ).then(billingSummary => {
                        const isAutoDraft = _.get(billingSummary, 'policyPeriodBillingSummaries[0].isAutoDraft_TWIA')
                        setAutoDraft(isAutoDraft);
                        if(isAutoDraft){
                            // ensure that the correct payment plan is shown if autopay is on.
                            const autoDraftPlans =  _.filter(paymentPlans, (plan) =>  plan.billingId === bindDataVM.selectedPaymentPlan.value);

                            setPaymentPlans(autoDraftPlans);
                        }else{
                            setPaymentPlans(_.get(submissionVM, 'bindData.paymentPlans.value'));
                        }
                    });
                    
                    updateWizardData(submissionVM);
    
                    const result = getAdditionalInterestData(paymentMethod, additionalInterestContacts);
    
                    setAdditionalInterest(() => result.additionalInterestContact);
                    setAdditionalInterestDetail(() => result.additionalInterestDetail)
                    setShowAdditionalInterestMessage(() => _.isEmpty(result.additionalInterestDetail));
                    setBindDataVM(() => _.get(submissionVM, 'bindData'));
                    setIsLoading(false);
                 });
            })
        })
        
    }, [])

    const getPremiumValue = useCallback(() => offeredQuoteData ?
        offeredQuoteData.premium.total : null, [offeredQuoteData]);


    const effectiveDateChange = useCallback(() => {
        if (steps.length === 1) {
            let periodStart = _.get(submissionVM, 'baseData.periodStartDate.value');
            if (submissionVM?.value?.baseData?.periodStatus === 'Submitted_Ext' && periodStart) {
                periodStart = LocalDateUtil.toMidnightDate(periodStart);
                const now = new Date();
                if (now > periodStart) {
                    submissionVM.baseData.periodStartDate.value = {
                        year: now.getFullYear(),
                        month: now.getMonth(),
                        day: now.getDate()
                    };
                }
            }
            updateWizardData(submissionVM);
        }
    }, [steps, submissionVM, updateWizardData])

    const onChangePaymentMethod = useCallback((value, path) => {
        _.set(bindDataVM, path, value);
        _.set(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value', false);

        if (value !== 'echeck') {
            disregardFieldValidation('Echeck');
            disregardFieldValidation('TWIAAddressComponent');
        }
        effectiveDateChange();
        setIsLoading(true);

        const job = _.cloneDeep(submissionVM.value);
        job.bindData.paymentDetails.electronicPaymentData_TWIA = null;
        LoadSaveService.retrievePaymentPlansByRenewal(job, authHeader)
        .then(paymentPlans => {
            if (_.includes(NO_PAYMENT_OPTION_METHODS, value) && !eftEnabled) {
                _.set(bindDataVM, 'paymentDetails.nonEFTPaymentOption_TWIA.value', undefined);
            } else if (_.includes(NO_PAYMENT_OPTION_METHODS, value)) {
                _.set(bindDataVM, 'paymentDetails.paymentOption_TWIA.value', undefined);
            } else if (value === 'mortgagee_escrow' && !eftEnabled) {
            _.set(bindDataVM, 'paymentDetails.nonEFTPaymentOption_TWIA.value', 'mortgagee_billed');
            } else if (value === 'mortgagee_escrow') {
                _.set(bindDataVM, 'paymentDetails.paymentOption_TWIA.value', 'mortgagee_billed');
            }
             _.set(bindDataVM, 'paymentPlans.value', paymentPlans);
            _.set(submissionVM, 'bindData', bindDataVM);
            setPaymentPlans(paymentPlans);
            updateWizardData(submissionVM);

            const result = getAdditionalInterestData(value, additionalInterestContacts);

            setAdditionalInterest(() => result.additionalInterestContact);
            setAdditionalInterestDetail(() => result.additionalInterestDetail)
            setShowAdditionalInterestMessage(() => _.isEmpty(result.additionalInterestDetail));
            setBindDataVM(() => bindDataVM);
            setSelectedPaymentPlan();
            setIsLoading(false);
        }); 
    }, [additionalInterestContacts, authHeader, bindDataVM, disregardFieldValidation, effectiveDateChange, getAdditionalInterestData, submissionVM, updateWizardData]);

    const onViewPaymentPlan = useCallback((rowData) => {
        const componentProps = {
            title: translator(messages.installmentPopupTitle),
            submissionVM,
            authHeader,
            rowData
        };

        showModal(
            <InstallmentsPopup {...componentProps} />
        );
    }, [authHeader, showModal, submissionVM, translator]);

    const onChangeEmail = useCallback((event, email) => {
        setIsLoading(true);
        _.set(submissionVM, 'bindData.contactEmailNotProducerEmail_TWIA.value', true);

        if (!_.isUndefined(email.value)) {
            try {
                CustomQuoteService.isProducerEmail(email.value, authHeader).then((response) => {
                    _.set(submissionVM, 'bindData.contactEmailNotProducerEmail_TWIA.value', !response);
                    setIsLoading(false);
                    if (response) {
                        setShowError(true);
                        setEmailMessage([translator(messages.producerEmailError)]);
                    } else {
                        setValidatingEmail(false);
                    }
                })
            } catch(err) {
                setValidatingEmail(false);
            }
        } else {
            _.set(submissionVM, 'bindData.contactEmailNotProducerEmail_TWIA.value', true);
        }

        setIsLoading(false);
        updateWizardData(submissionVM);
        setBindDataVM(() => _.get(submissionVM, 'bindData'));
    }, [authHeader, submissionVM, updateWizardData]);

    const showPaymentMethod = useCallback(() => {
        const selectedPaymentMethod = getSelectedPaymentMethod()

        return !_.includes(NO_PAYMENT_OPTION_METHODS, selectedPaymentMethod)
    }, [NO_PAYMENT_OPTION_METHODS, getSelectedPaymentMethod])

    const navigateToAdditionalInfoScreen = useCallback(() => {
        showConfirm({
            title: wizardMessages.TWIAWizardModalTitle,
            message: wizardMessages.TWIAWizardModalMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
            cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            // eslint-disable-next-line consistent-return
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            // DE16417
            resetElectronicPaymentData();

            if (TWIASubmissionHelper.isHomeOwners(submissionVM.value)) {
                jumpTo(4);
            } else {
                jumpTo(3);
            }
        }, _.noop)
    }, [jumpTo, resetElectronicPaymentData, showConfirm, submissionVM]);

    const getAdditionalInterestMessage = useCallback(() => {
        if(getSelectedPaymentMethod() === 'prem_fina_other') {
            return TWIASubmissionHelper.isHomeOwners(submissionVM.value) ? (
                translator(messages.additionalMessagePF, {
                    Link: chunks => <Link style={{ textDecorationLine: 'underline'}} onClick={() => { navigateToAdditionalInfoScreen() }}>{chunks}</Link>
                })
            ) : (
                translator(messages.commercialPfMessage, {
                    Link: chunks => <Link style={{ textDecorationLine: 'underline'}} onClick={() => { navigateToAdditionalInfoScreen() }}>{chunks}</Link>
                })
            )
        }

        if (getSelectedPaymentMethod() === 'mortgagee_escrow') {
            return TWIASubmissionHelper.isHomeOwners(submissionVM.value) ? (
                translator(messages.additionalMessageMortgagee, {
                    Link: chunks => <Link style={{ textDecorationLine: 'underline'}} onClick={() => { navigateToAdditionalInfoScreen('mortgageee') }}>{chunks}</Link>
                })
            ) : (translator(messages.commercialMortgageMessage))
        }

        return null;
    }, [getSelectedPaymentMethod, navigateToAdditionalInfoScreen, submissionVM, translator]);

    // DE16427 is the selected payment plan autodraft
    const isAutoPay = useCallback(() => {
        const paymentPlans = _.get(submissionVM, 'bindData.paymentPlans.value');
        const selectedPlan = _.get(submissionVM, 'bindData.selectedPaymentPlan.value');
        let autoPay = false;

        if (paymentPlans && selectedPlan) {
            const selectedPaymentPlan = _.find(paymentPlans, plan => plan.billingId === selectedPlan);

            autoPay = _.get(selectedPaymentPlan, 'autoDraftPlan_TWIA');
        }

        return autoPay;
    }, [submissionVM]);

    _.set(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value', isAutoPay());

    const writeValue = useCallback((value, path) => {
        _.set(bindDataVM, path, value);
        _.set(submissionVM, 'bindData', bindDataVM);
        if(_.includes(path, 'Option_TWIA') && value !== 'echeck'){
            disregardFieldValidation('Echeck');
            disregardFieldValidation('TWIAAddressComponent');
        }
        _.set(submissionVM, 'bindData.isAutoPayEnabled_TWIA.value', isAutoPay());

        setEmailMessage([]);

        if (!_.isNil(ceUserName) && contactEmail && !contactEmail.aspects.valid) {
            setEmailMessage([translator(messages.policyholderEmailRequired)])
            setShowError(true);
            // DE17818
        } else if (!isAutoPay() && _.isNil(contactEmail?.value) && contactEmail.aspects.required) {
            setEmailMessage([translator(messages.required)]);
            setShowError(true);
        } else if (!isAutoPay() && contactEmail && !contactEmail.aspects.valid) {
            setEmailMessage([translator(messages.emailValidationMessage)]);
            setShowError(true);
        } else if (isAutoPay() && contactEmail && !contactEmail.aspects.valid) {
            setEmailMessage([translator(messages.validate10PayEmail)]);
            setShowError(true);
        }
        if (path === 'contactEmail') {
            setValidatingEmail(true);
        }

        updateWizardData(submissionVM);
        setBindDataVM(() => _.get(submissionVM, 'bindData'));
    }, [bindDataVM, disregardFieldValidation, isAutoPay, submissionVM, translator, 
        updateWizardData, ceUserName, contactEmail]);

    // DE17446
    const getAutoPayContainer = () => (
        <div className={styles.consentScroll}>
            <div className={styles.displaydiv}>
                <div className={styles.divpadding}>
                    <Icon icon="gw-info" size="large" className={styles.iconColor} />
                </div>
                <div>
                    <div>
                        <p>{translator(messages.autoPayMessage)}</p>
                    </div>
                    <div>
                        <Button onClick={()=>editPayPlans()}>
                        {translator(messages.autoPayButtonText)}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )

    const editPayPlans = () => {
        showConfirm({
            title: messages.autoPayPopupTitle,
            message: messages.autoPayPopupMessage,
            status: 'warning',
            icon: 'mi-warning-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel,
        })
        .then((results)=> {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }
            const paymentPlans = _.get(submissionVM, 'bindData.paymentPlans.value');
            if (paymentPlans) {
                const replacePlan = paymentPlans.find(plan => plan.resetAutoDraftPlan_TWIA);
                if (replacePlan) {
                   _.set(submissionVM,'bindData.selectedPaymentPlan.value',replacePlan.billingId) ;
                    _.set(submissionVM,'bindData.selectedPaymentPlanAutoDraft_TWIA.value',replacePlan.autoDraftPlan_TWIA);
                }
            }

            setAutoDraft(false);
            setPaymentPlans(_.get(submissionVM, 'bindData.paymentPlans.value'));
        }, _.noop);
    };

    const setSelectedPaymentPlan = useCallback(()=>{
        const paymentPlansNew = _.get(submissionVM, 'bindData.paymentPlans.value')
        if (paymentPlansNew && paymentPlansNew.length === 1 && paymentPlansNew[0] !== undefined) {
            _.set(submissionVM,'bindData.selectedPaymentPlan.value',paymentPlansNew[0].billingId);
           
            _.set( submissionVM,'bindData.selectedPaymentPlanAutoDraft_TWIA.value',paymentPlansNew[0]?.autoDraftPlan_TWIA)
        }
        updateWizardData(submissionVM);
        setBindDataVM(() => _.get(submissionVM, 'bindData'));
    },[submissionVM,updateWizardData])

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        paymentPlansTable: {
            paymentPlans,
            autoDraft,
            bindDataVM,
            writeValue,
            onViewPaymentPlan,
        },
        totalPremium: {
            value: getPremiumValue()
        },
        playmentPlanText: {
            content: translator(messages.paymentPlanText)
        },
        paymentMethodWithEft: {
            disabled: autoDraft,
            visible: eftEnabled
        },
        paymentMethod: {
            disabled: autoDraft,
            visible: !eftEnabled
        },
        paymentOptionWithEft: {
            visible: eftEnabled && showPaymentMethod()
        },
        paymentOption: {
            visible: !eftEnabled && showPaymentMethod()
        },
        additionalInterestText: {
            visible: _.includes(ADDITIONAL_INTEREST_OPTIONS, getSelectedPaymentMethod())
                && showAdditionalIntMessage,
            message: getAdditionalInterestMessage()
        },
        pfMessageText: {
            visible: getSelectedPaymentMethod() === 'prem_fina_other' && !showAdditionalIntMessage,
            content: translator(messages.pfMessage)
        },
        aiName: {
            visible: !_.isUndefined(additionalInterest) && _.includes(ADDITIONAL_INTEREST_OPTIONS,
                getSelectedPaymentMethod()),
            label: getSelectedPaymentMethod() === 'prem_fina_other'
                ? translator(messages.pfCompany) : translator(messages.mortgagee),
            value: additionalInterest?.displayName
        },
        loanNumber: {
            visible: !_.isUndefined(additionalInterestDetail) && !_.isEmpty(additionalInterest)
                && _.includes(ADDITIONAL_INTEREST_OPTIONS, getSelectedPaymentMethod()),
            value: additionalInterestDetail?.contractNumber
        },
        tenPayMsg: {
            visible: isAutoPay(),
            message: translator(messages.tenPayMsg)
        },
        echeckDetails: {
            visible: !_.isUndefined(_.get(bindDataVM, 'paymentDetails.electronicPaymentData_TWIA.value'))
                && (getSelectedPaymentMethod() === 'echeck' || getSelectedPaymentOption() === 'echeck'),
            bindDataVM,
            writeValue,
            onValidate,
            showError
        },
        emailAddress: {
            required: isAutoPay() || !_.isNil(ceUserName) || isAutoPayEnabled,
            showRequired: isAutoPay() || !_.isNil(ceUserName) || isAutoPayEnabled,
            validationMessages: emailMessage
        },
        autoPayContainer:{
            visible: autoDraft,
            content : getAutoPayContainer()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onChangePaymentMethod,
            writeValue,
            onChangeEmail
        },
        resolveComponentMap: {
            paymentPlansTableComponent: PaymentPlansTable,
            echeckDetailsComponent: Echeck
        },
        resolveClassNameMap: styles
    };

    const handleNext = useCallback(() => {
        showConfirm({
            title: messages.confirmTransaction,
            message: messages.confirmTransactionMsg,
            status: 'warning',
            icon: 'gw-help',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: commonMessages.cancelModel,
            // eslint-disable-next-line consistent-return
        }).then((results) => {
            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            setShowSubmitLoader(true);

            const checkUwIssues = CustomQuoteService.getUWIssueStatus(jobID, sessionID, authHeader);

            checkUwIssues.then((result) => {
                if (result.anyPolicyHoldUWIssues) {
                    setShowSubmitLoader(false);
                    showAlert({
                        title: '',
                        message: messages.uwPolicyHold_twia,
                        status: 'error',
                        icon: 'mi-error-outline',
                        cancelButtonText: commonMessages.cancelModel,
                    }).then((res) => {
                        if (res === 'confirm') {
                            // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                            submissionVM.noCancelWarning = true;
                            history.push(`${process.env.PUBLIC_PATH}/renewal/${submissionVM.jobID.value}/summary`)
                        }
                    })
                }
                else if (result.anyOtherBlockingUWIssues) {
                    setShowSubmitLoader(false);
                    showAlert({
                        title: '',
                        message: messages.uwOtherBlockingIssue_twia,
                        status: 'error',
                        icon: 'mi-error-outline',
                        cancelButtonText: commonMessages.cancelModel,
                    }).then((res) => {
                        if (res === 'confirm') {
                            // 2024-12-24 - Debra Frum - DE17681 - Unable to navigate to Renewal Summary screen from Payment screen
                            // Suppress the Cancel confirmation popup
                            submissionVM.noCancelWarning = true;
                            history.push(`${process.env.PUBLIC_PATH}/renewal/${submissionVM.jobID.value}/summary`)
                        }
                    })
                }
                else {
                    const job = _.cloneDeep(submissionVM.value);

                    if (getSelectedPaymentMethod() !== 'echeck' && getSelectedPaymentOption() !== 'echeck') {
                        job.bindData.paymentDetails.electronicPaymentData_TWIA = null
                    }

                    const submit = LoadSaveService.submitOrBind([job], authHeader);

                    submit.then((response) => {
                        const electronicData = submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value;
                        submissionVM.value = response;
                        submissionVM.bindData.paymentDetails.electronicPaymentData_TWIA.value =
                            electronicData || {}
                        updateWizardData(submissionVM) 
                        // 2024-12-29 - Debra Frum - DE17673 - Suppress the Exit confirmation popup
                        submissionVM.noCancelWarning = true;
                        return history.push({
                            pathname: '/renewalConfirmation',
                            state: {
                                response,
                                authHeader
                            },
                        });
                    }).catch((err) => {
                        setShowSubmitLoader(false);
                        // DE17798
                        
                        const errorMessage = _.split(err.baseError, 'ErrorMessage: ')[1];
                        const errorCode = _.get(err, 'appErrorCode');

                        if (errorMessage.includes("greaterThanMax")) {
                            showAlert({
                                title: messages.paymentThreshold,
                                message: messages.paymentThresholdMsgR352,
                                status: 'error',
                                icon: 'mi-error-outline',
                                confirmButtonText: commonMessages.ok,
                            })
                        } else if (errorMessage.includes("Getting Time Out to Pay and Issue process for job") ||
                            errorMessage.includes("Error occurred during Pay and Issue process for job")) {
                            showAlert({
                                title: commonMessages.genericError,
                                message: messages.unableToProcessPayment,
                                status: 'error',
                                icon: 'mi-error-outline',
                                confirmButtonText: commonMessages.ok,
                            })
                        } else {
                            switch (errorCode) {
                                case 10075:
                                    showAlert({
                                        title: messages.invalidBank,
                                        message: messages.badBank,
                                        status: 'error',
                                        icon: 'mi-error-outline',
                                        confirmButtonText: commonMessages.ok,
                                    })
                                    break;
                                case 10074:
                                    showAlert({
                                        title: messages.paymentThreshold,
                                        message: messages.paymentThresholdMsg,
                                        status: 'error',
                                        icon: 'mi-error-outline',
                                        confirmButtonText: commonMessages.ok,
                                    })
                                    break;
                                // DE18802 handle UW issues at issuance
                                case 602:
                                    setShowSubmitLoader(false);
                                    showAlert({
                                        title: '',
                                        message: messages.uwOtherBlockingIssue_twia,
                                        status: 'error',
                                        icon: 'mi-error-outline',
                                        cancelButtonText: commonMessages.cancelModel,
                                    }).then((res) => {
                                        if (res === 'confirm') {
                                            submissionVM.noCancelWarning = true;
                                            history.push(`${process.env.PUBLIC_PATH}/renewal/${jobID}/summary`)
                                        }
                                    })
                                    break;
                                default:
                                    ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
                                    break;
                            }
                        }
                        return false;
                    });
                }
            }, _.noop)
        })
    }, [authHeader, getSelectedPaymentMethod, getSelectedPaymentOption, history, jobID, sessionID, showAlert, showConfirm, submissionVM, updateWizardData]);

    const isNextDisabled = useCallback(() => {
        if((_.includes(DISABLE_SUBMIT_OPTIONS, getSelectedPaymentMethod())
            || getSelectedPaymentOption() === 'mortgagee_billed')
            && _.get(submissionVM, 'baseData.periodStatus.value.code') === 'Submitted_Ext'){
            return true
        }
        const isAdditionalInterestSelected = _.includes(ADDITIONAL_INTEREST_OPTIONS, 
            getSelectedPaymentMethod()) && showAdditionalIntMessage;
        // DE17344,DE17388
        return (!isComponentValid) || isAdditionalInterestSelected || validatingEmail;

    }, [ADDITIONAL_INTEREST_OPTIONS, submissionVM, getSelectedPaymentMethod, 
        showAdditionalIntMessage, isComponentValid, validatingEmail]);

    const hideSaveAndExit = useCallback(() => {
        const paymentMethod = getSelectedPaymentMethod();
        const paymentOption = getSelectedPaymentOption();
        const isRenewalSubmitted = _.get(submissionVM, 'baseData.periodStatus.value.code')
        === 'Submitted_Ext'
        return _.includes(NO_SAVE_AND_EXIT_OPTIONS, paymentMethod) || 
        _.includes(NO_SAVE_AND_EXIT_OPTIONS, paymentOption) || isRenewalSubmitted
    }, []);

    const handleSaveAndExit = useCallback(() => {
        setIsLoading(true);
        _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
        LoadSaveService.renew_TWIA([submissionVM.value], authHeader).then((response) => {
                submissionVM.value = response
                updateWizardData(submissionVM);
                setIsLoading(false);
                history.push(`${process.env.PUBLIC_PATH}/renewal/${submissionVM.jobID.value}/summary`)         
            });
    }, []);

    return (
        <WizardPage
            nextLabel={messages.paymentBuyNow}
            showNext={!showSubmitLoader}
            showPrevious={submissionVM.baseData.periodStatus.value.code === 'Submitted_Ext'
                ? false : !showSubmitLoader}
            showCancel={!showSubmitLoader}
            hideHeader={showSubmitLoader}
            showSaveExit={!hideSaveAndExit() && !showSubmitLoader}
            onSaveAndExit={handleSaveAndExit}
            onNext={handleNext}
            onPrevious={resetElectronicPaymentData}
            disableNext={isNextDisabled()}
            disableSaveExit={!isComponentValid || validatingEmail}
            disablePrevious={validatingEmail}
        >
            {!showSubmitLoader ? 
            (<Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={bindDataVM}
                    onModelChange={updateWizardData}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                    callbackMap={resolvers.resolveCallbackMap}
                    showErrors={showError}
                />
            </Loader>) : 
            (<Loader
                loaded={!showSubmitLoader}
                text="Processing Transaction..."
            />)}
        </WizardPage>
    );
}

TWIAPaymentDetailsPage.propTypes = wizardProps;
export default TWIAPaymentDetailsPage;
